<template>
  <div>
    <ion-menu side="start" type="push" content-id="main">
      <ion-header>
        <ion-toolbar color="secondary">
          <ion-title>
            <fa :icon="['fad', 'headset']" class="fa-fw ml-2" style="font-size:23px;"></fa>
            MESA DE AYUDA
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-menu-toggle auto-hide="true">
            <ion-item lines="none" detail="false" class="hydrated" v-for="(item, index) in menu" :key="'k'+index" @click="this.$router.replace(item.url)">
              <fa :icon="['fas', item.icono]" class="fa-fw" style="margin-right:15px; font-size:20px;"></fa>
              <ion-label>{{ item.titulo }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
      
      <ion-footer class="bar-stable">
        <ion-menu-toggle auto-hide="true">
        <ion-item nav-clear menu-close @click="muestraModalAjustes();">
          <fa :icon="['fad', 'cog']" class="fa-fw" style="margin-right:15px; font-size:20px;"></fa>
          AJUSTES
        </ion-item>
        </ion-menu-toggle>
        <ion-item nav-clear menu-close @click="alertCerrarSesion();">
          <fa :icon="['fad', 'sign-out-alt']" class="fa-fw" style="margin-right:15px; font-size:20px;"></fa>
          CERRAR SESION
        </ion-item>
      </ion-footer>
    </ion-menu>

    <ion-router-outlet id="main"></ion-router-outlet>
  </div>

</template>

<script>
import { 
  IonContent, 
  IonHeader, 
  IonFooter,
  IonItem, 
  IonList, 
  IonMenu, 
  IonRouterOutlet,
  IonTitle, 
  IonToolbar,
  IonMenuToggle,
  alertController,
  modalController,
  IonLabel
} from '@ionic/vue';

import { defineComponent }  from 'vue';
import { Preferences } from '@capacitor/preferences';

import { cerrarSesion }   from '@/plugins/funciones.ts';
import Ajustes            from '../components/Ajustes.vue'

export default defineComponent({
  name: 'Menu',
  components: {
    IonContent, 
    IonHeader, 
    IonFooter,
    IonItem, 
    IonList, 
    IonMenu, 
    IonRouterOutlet,
    IonTitle, 
    IonToolbar,
    IonMenuToggle,
    IonLabel
  },
  mounted() {
    this.validarSesion();

  }, 
  data(){   
    return {
      modalAjustes  : null,
      menu          : []
    }
  },
  
  methods: {
    async validarSesion(){
      const modoOscuro = await Preferences.get({ key: 'modo_oscuro' });
      if (modoOscuro.value == '1'){
        document.body.classList.add('dark');
      }
      else{
        document.body.classList.remove("dark");
      }
      const token   = await Preferences.get({ key: 'token_auth' });
      if (token.value == null || token.value == ''){
        cerrarSesion();
      }
      else{
        const cambioClave   = await Preferences.get({ key: 'cambio_clave' });
        if (cambioClave.value == 1 || cambioClave.value == '1'){
          this.muestraModalAjustes(true);
        }
        
        const tipoUsuario = await Preferences.get({ key: 'tipo_usuario' });
        if(tipoUsuario.value == '1'){       // TIPO DE USUARIO ADMINISTRADOR
          this.menu = [
            { titulo: 'EVENTOS'       , icono: 'bell'                   , url: '/menu/soporte/eventos'              },
            { titulo: 'HISTORIAL'     , icono: 'clipboard-list'         , url: '/menu/soporte/historial'            },
            { titulo: 'USUARIOS'      , icono: 'user'                   , url: '/menu/administrador/usuarios'       },
            { titulo: 'TIPOS EVENTOS' , icono: 'pen-to-square'          , url: '/menu/administrador/tipos_eventos'  },
            { titulo: 'REPORTES'      , icono: 'file-alt'               , url: '/menu/reportes/reportes'            },
            { titulo: 'TURNOS'        , icono: 'calendar-alt'           , url: '/menu/turnos'                       },
            { titulo: 'INFORMACIÓN'   , icono: 'info-circle'            , url: '/menu/informacion'                  }

          ]
        }
        else if(tipoUsuario.value == '2'){ // TIPO DE USUARIO SOPORTE INFORMATICO
          this.menu = [
            { titulo: 'EVENTOS'       , icono: 'bell'                   , url: '/menu/soporte/eventos'              },
            { titulo: 'HISTORIAL'     , icono: 'clipboard-list'         , url: '/menu/soporte/historial'            },
            { titulo: 'TURNOS'        , icono: 'calendar-alt'           , url: '/menu/turnos'                       },
            { titulo: 'INFORMACIÓN'   , icono: 'info-circle'            , url: '/menu/informacion'                  }
          ]
        }
        else if(tipoUsuario.value == '3'){ // TIPO DE USUARIO SOPORTE TECNICO
          this.menu = [
            { titulo: 'EVENTOS'       , icono: 'bell'                   , url: '/menu/soporte/eventos'              },
            { titulo: 'HISTORIAL'     , icono: 'clipboard-list'         , url: '/menu/soporte/historial'            },
            { titulo: 'TURNOS'        , icono: 'calendar-alt'           , url: '/menu/turnos'                       },
            { titulo: 'INFORMACIÓN'   , icono: 'info-circle'            , url: '/menu/informacion'                  }
          ]
        }
        else if(tipoUsuario.value == '4'){ // TIPO DE USUARIO NORMAL
          this.menu = [
            { titulo: 'PENDIENTES'    , icono: 'clock'                  , url: '/menu/normal/pendientes'            },
            { titulo: 'HISTORIAL'     , icono: 'clipboard-list'         , url: '/menu/normal/historial'             },
            { titulo: 'TURNOS'        , icono: 'calendar-alt'           , url: '/menu/turnos'                       },
            { titulo: 'INFORMACIÓN'   , icono: 'info-circle'            , url: '/menu/informacion'                  }
          ]
        }
        else if(tipoUsuario.value == '5'){ // TIPO DE USUARIO PARA REPORTES
          this.menu = [
            { titulo: 'REPORTES'      , icono: 'file-alt'               , url: '/menu/reportes/reportes'            }
          ] 
        }
        else if(tipoUsuario.value == '6'){ // TIPO DE USUARIO PARA REPORTES
          this.menu = [
            { titulo: 'EVENTOS'       , icono: 'bell'                   , url: '/menu/soporte/eventos'              },
            { titulo: 'HISTORIAL'     , icono: 'clipboard-list'         , url: '/menu/soporte/historial'            },
            { titulo: 'TURNOS'        , icono: 'calendar-alt'           , url: '/menu/turnos'                       },
            { titulo: 'INFORMACIÓN'   , icono: 'info-circle'            , url: '/menu/informacion'                  }
          ]
        }
        else if(tipoUsuario.value == '99'){ // TIPO DE USUARIO PARA GOOGLE
          this.menu = [
            { titulo: 'PENDIENTES'    , icono: 'clock'                  , url: '/menu/normal/pendientes'            },
            { titulo: 'HISTORIAL'     , icono: 'clipboard-list'         , url: '/menu/normal/historial'             },
            { titulo: 'INFORMACIÓN'   , icono: 'info-circle'            , url: '/menu/informacion'                  }
          ]
        }
      }
    },

    async muestraModalAjustes(cambioClave=false){
      this.modalAjustes = await modalController
        .create({
          component: Ajustes,
          componentProps: {
            modal: this.modalAjustes,
            propCambioClave: cambioClave
          },
          //backdropDismiss: false,
          cssClass: 'modal-class'
        });
      this.modalAjustes.present();
      //const modalResponse = await this.modalAjustes.onDidDismiss();
      await this.modalAjustes.onDidDismiss();
      
      //modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    /* modalCloseHandler(_value) {
      const datos = _value;
      //console.log(datos);
    }, */

    async alertCerrarSesion() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'CERRAR SESIÓN',
          message: '¿Desea cerrar la sesión?',
          buttons: [
            {
              text: 'CANCELAR',
              role: 'cancel',
              cssClass: 'secondary',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: 'CERRAR',
              role: 'ok',
              cssClass: 'primary',
              handler: () => {
                cerrarSesion();
              },
            },
          ],
        });
      return alert.present();
    },

  }
});

</script>

<style>
.my-custom-menu {
  --width: 500px;
}

.modal-class {
  ion-backdrop {
    --backdrop-opacity: 0.33;
  }
}

</style>